import Request from './request';

export const apiCreateCustomField = async (companyId, type, data = {}) => {
  return Request.call({
    url: `/company/${companyId}/custom-field/${type}`,
    method: 'POST',
    data,
  });
};

export const apiUpdateCustomField = async (companyId, type, data = {}) => {
  return Request.call({
    url: `/company/${companyId}/custom-field/${type}`,
    method: 'POST',
    data,
  });
};
export const apiDeleteCustomField = async (companyId, type, data = {}) => {
  return Request.call({
    url: `/company/${companyId}/custom-field/${type}`,
    method: 'DELETE',
    data,
  });
};
